export default () => (subject) => {
  navigator.clipboard.writeText(subject);
};
